  $(document).ready(function(){     
    //setTimeout(function(){//if ($(window).width() < 1200) {    //$('#insta-feed').slick({//slidesToShow: 3.5,//slidesToScroll: 1,//arrows: false,//dots:false,//infinite:false,//responsive: [//{//breakpoint: 992,//settings: {//slidesToShow: 2.5,//}//},    //{//breakpoint: 481,//settings: {//slidesToShow: 1.44,//}//}//]// });//}//},3000);
    $('.main-reviews-block').slick({
  slidesToShow: 2,
  slidesToScroll: 1,
  arrows: false,
  dots:true,
  infinite:false,
       responsive: [
    {
      breakpoint: 992,
      settings: {
        slidesToShow: 1,
      }
    }    
  ]
    });
     $('.template-index .blog .blog__posts.articles-wrapper').slick({
  slidesToShow: 3,
  slidesToScroll: 1,
  arrows: true,
  dots:false,
  draggable:false,
  prevArrow: $('.prev-blog'),
  nextArrow: $('.next-blog'),
  infinite:false,
       responsive: [
    {
      breakpoint: 1200,
      settings: {
        slidesToShow: 2,
        draggable:true,
      }
    },
         {
      breakpoint: 749,
      settings: {
        slidesToShow: 1,
        adaptiveHeight:true,
      }
    }   
 ]
    });    
});
$(window).on("load", function() {
    $("#preloader").fadeOut("slow");
});